import React, { useState } from 'react';
import './TacoBell.css';

const TacoBell = () => {
  const [isRetro, setIsRetro] = useState(false);

  const toggleTheme = () => {
    setIsRetro(!isRetro);
  };

  const retroMenuItems = [
    { id: 1, name: 'Crunchy Taco', price: '$1.79', img: '/picz/tacobell/crunchy_taco_269x269.jpg' },
    { id: 2, name: 'Chalupa Supreme', price: '$1.49', img: '/picz/tacobell/chalupa_supreme_269x269.jpg' },
    { id: 3, name: 'Mexican Pizza', price: '$1.29', img: '/picz/tacobell/mexican_pizza_269x269.jpg' },
    { id: 4, name: 'Quesadilla', price: '$1.29', img: '/picz/tacobell/quesadilla_269x269.jpg' },
  ];

  const modernMenuItems = [
    { id: 1, name: 'Crispy Chicken Chipotle Bacon Melt Burrito', price: '$5.99', img: '/picz/tacobell/CrispyChickenChipotleBaconMeltBurrito_ALC_WebLanding_Carousel-jpg.avif' },
    { id: 2, name: 'Pepper Jack Steak Nacho Fries', price: '$5.99', img: '/picz/tacobell/Pepper-Jack-Steak-Nacho-Fries-ALC-Web-Carousel-720x720-jpg.avif' },
    { id: 3, name: 'Baja Blast', price: '$3.29', img: '/picz/tacobell/mountain_dew_baja_blast_dirty_soda_269x269.jpg' },
    { id: 4, name: 'Large Nacho Fries', price: '$3.89', img: '/picz/tacobell/ChickenFajitaNachoFries_Carousel_LargeNF-png.avif' },
  ];

  const menuItems = isRetro ? retroMenuItems : modernMenuItems;

  return (
    <div className={`taco-page ${isRetro ? 'retro' : 'modern'}`}>
      {/* Navigation */}
      <nav className="tb-nav">
        <div className="tb-logo">
          {isRetro ? (
            <img
              src="/picz/tacobell/tacobell-logo.svg"
              alt="Taco Bell Retro Logo"
              style={{ height: '40px' }}
            />
          ) : (
            'Taco Bell'
          )}
        </div>
        <button className="theme-switch" onClick={toggleTheme}>
          Switch to {isRetro ? 'Modern' : 'Retro'} Mode
        </button>
      </nav>

      {/* Hero Section */}
      <header className="tb-hero">
        {isRetro ? (
          <img
            src="/picz/tacobell/taco_bell_90s1024x450.webp"
            alt="Retro Taco Bell"
            className="tb-hero-img"
          />
        ) : (
          <img
            src="https://dam.tacobell.com/transform/fd43ff74-0ac2-4191-a619-acba2bc1a48d/E85_26_NAT_TajinTaco_Modules_0728_Desktop_Hero_0728-jpg"
            alt="Modern Taco Bell"
            className="tb-hero-img"
          />
        )}
        <div className="tb-hero-content">
          <h2>{isRetro ? 'LIVE MAS! Since 1964' : 'Live Mas.'}</h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '1.2rem', marginBottom: '30px' }}>
            {isRetro
              ? 'Welcome to the bold flavors of the past!'
              : 'The boldest flavors in the game.'}
          </p>
          <a href="#menu" className="tb-cta-btn">
            {isRetro ? 'Order Now' : 'Order Now'}
          </a>
        </div>
      </header>

      {/* Menu Section */}
      <section id="menu" className="tb-menu">
        {menuItems.map(item => (
          <div key={item.id} className="tb-item">
            <img src={item.img} alt={item.name} />
            <h3>{item.name}</h3>
            <p>{item.price}</p>
            <button className="theme-switch" style={{ width: '100%' }}>
              Add to Order
            </button>
          </div>
        ))}
      </section>
    </div>
  );
};

export default TacoBell;
